import shareAltOutlined from '@iconify/icons-ant-design/share-alt-outlined';
import { InlineIcon } from '@iconify/react';
import { StyledInput } from '@/widgets/components/input';
import copy from 'copy-to-clipboard';
import React from 'react';
import { InputGroup, Whisper } from 'rsuite';
import { AlertMsgClipboard } from '@/alert-string-constants';
import { ICON_COLOR, ICON_SIZE_PX } from '@/controls/menu-constants';
import { StyledBalloon } from './dash-content-action-menu-styles';
import {
  CopyButtonContent,
  PopoverContentWrapper,
  StyledPopover,
} from './popover-styles';
import { toaster } from '@/utils/toaster';
function ShareIcon() {
  return (
    <StyledBalloon
      aria-label="Share"
      data-balloon-pos="down"
      data-balloon-blunt
      className="action-menu-balloon-tooltip"
    >
      <InlineIcon
        icon={shareAltOutlined}
        color={ICON_COLOR}
        width={ICON_SIZE_PX}
        height={ICON_SIZE_PX}
      />
    </StyledBalloon>
  );
}

function copyUrl(url) {
  copy(url);
  toaster.info(AlertMsgClipboard);
}

function PopoverContent({ url }) {
  return (
    <PopoverContentWrapper>
      <InputGroup>
        <StyledInput id="share-textbox" value={url} />
        <InputGroup.Button>
          <CopyButtonContent onClick={() => copyUrl(url)}>
            COPY
          </CopyButtonContent>
        </InputGroup.Button>
      </InputGroup>
    </PopoverContentWrapper>
  );
}

/**
 * Renders icon button the opens popover onClick. Used in the dashboard action-menu.
 * Availability is determined inside the component
 */
export function SharePopover(props) {
  if (props.hide) return null;

  const popover = (
    <StyledPopover title="Share Property">
      <PopoverContent url={window.location.href} />
    </StyledPopover>
  );
  return (
    <Whisper placement="bottomEnd" trigger="click" speaker={popover}>
      <div>
        <ShareIcon />
      </div>
    </Whisper>
  );
}
